import React from "react";
import MainLoader from "../MainLoader";

const CategoryDetailsLoader = () => {
    return (
        <MainLoader />
    )
}

export default CategoryDetailsLoader;